import { Location } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { LoggedOutGuard } from './logged-out/logged-out.guard';

@Injectable({
  providedIn: 'root'
})
export class AccessDeniedRedirectService {
  private static readonly ACCESS_DENIED_ERROR = 'access_denied';
  private static readonly ACCESS_DENIED_REASON = 'access-denied';

  constructor(
    private readonly router: Router,
    private readonly location: Location,
    @Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth
  ) {}

  isAccessDeniedFromRoute(route: ActivatedRoute): boolean {
    return route.snapshot.queryParamMap.get('error') === AccessDeniedRedirectService.ACCESS_DENIED_ERROR;
  }

  isAccessDeniedFromCurrentUrl(): boolean {
    const currentPath = this.location.path(true);
    const queryString = currentPath.includes('?') ? currentPath.split('?')[1] : '';

    if (!queryString) {
      return false;
    }

    return new URLSearchParams(queryString).get('error') === AccessDeniedRedirectService.ACCESS_DENIED_ERROR;
  }

  private getAccessDeniedErrorDescriptionFromCurrentUrl(): string | null {
    const currentPath = this.location.path(true);
    const queryString = currentPath.includes('?') ? currentPath.split('?')[1] : '';

    if (!queryString) {
      return null;
    }

    return new URLSearchParams(queryString).get('error_description');
  }

  async navigateToAccessDenied(): Promise<void> {
    const message = this.getAccessDeniedErrorDescriptionFromCurrentUrl();

    this.oktaAuth.clearStorage();

    LoggedOutGuard.setAllowAccess(true);
    const queryParams: Record<string, string> = {
      reason: AccessDeniedRedirectService.ACCESS_DENIED_REASON
    };
    if (message) {
      queryParams['message'] = message;
    }

    await this.router.navigate(['/logged-out'], { queryParams });
  }
}
